<ng-template [ngIf]="selectedSection != null">
  <mat-drawer-container autosize>
    <mat-drawer class="pt-5" #drawer mode="side" opened>
      <div *ngIf="isStandaloneSurvey">
        <div class="mt-3">
          <strong style="font:600;" class="mat-drawer-title font18">Assessment / Survey</strong>
        </div>
        <div class="m-4">
          <div *ngIf="standaloneSurveyDetails != null && standaloneSurveyDetails.sections.length > 0">
            <div *ngFor="let sec of surveyViewModel.sections;let i = index;">
              <div class="row d-flex p-2 col-12" style="font-weight:500;font-size: large;cursor: pointer;display:flex;justify-content: center;align-items: center;"
                (click)="onClickOfSection(0,i)" [ngClass]="{'selected-style': sec.isSectionSelected}">
                <!-- <mat-icon>arrow_right</mat-icon><span class="font14">{{sec.sectionName}}</span> -->
                <div class="col-1"><span class="dot mr-3 mt-1" [ngStyle]="{'background-color': sec.sectionDotColor}"></span></div>
                <div class=" col-10 pr-0 dotTitle fontstyle">{{sec.sectionName}}</div>
              </div>
            </div>
          </div>
          <div *ngIf="standaloneSurveyDetails != null && standaloneSurveyDetails.sections.length == 0">
            <em>No sections Available!!</em>
          </div>
        </div>
      </div>
      <div *ngIf="!isStandaloneSurvey">

        <div *ngIf="IsWorkflow">
          <div class="mat-title pt-3">
            <strong style="font:600;" class="pl-3">Performance-Based Contracting</strong>
          </div>          
          <div class="my-2 mx-3">
            <div class="pt-3" *ngIf="wfSteps.length > 0">
              <div *ngFor="let step of wfSteps;let i = index;">
                <div class="my-2 mat-body-2 cursor stepNameFontSize">{{step.name}}</div>
                <div *ngIf="step.sectionsList.length > 0">
                  <div class="mt-1" *ngFor="let section of step.sectionsList;let j = index;">
                    <div *ngIf="section.isSecParentQuestionVisible" class="ml-1 p-2 d-flex row cursor col-12"
                     style="justify-content: left;align-items: center;"
                     (click)="onClickOfSection(i,getVisibleSectionIndex(step.sectionsList, j))"
                      [ngClass]="{'selected-style': section.isSectionSelected,'resolution-section':getFailedSectionIds().has(section.sectionId),'resolution-selected-section':getFailedSectionIds().has(section.sectionId) && section.isSectionSelected}">
                      <!-- <mat-icon>arrow_right</mat-icon><span class="mat-body-1">{{section.sectionName}}</span> -->
                      <div class="p-0 col-1"><span class="mr-3 mt-1" [ngClass]="getFailedSectionIds().has(section.sectionId)?'triangle':'dot'" *ngIf="section != null && section.sectionDotColor != null"
                         [ngStyle]="{'background-color':section.sectionDotColor}"></span></div>
                      <div class="col-10 pr-0 pl-0 dotTitle fontstyle" [ngClass]="getFailedSectionIds().has(section.sectionId)?'resolution-section-title':''">{{section.sectionName}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!IsWorkflow">
          <div class="mat-title pt-3">
            <strong style="font:600;" class="pl-4">Assessment / Survey</strong>
          </div>
          <div class="m-4">
            <div *ngIf="surveyViewModel != null && surveyViewModel.sections.length > 0">
              <div *ngFor="let sec of surveyViewModel.sections;let i = index;">
                <!-- <div class="p-2" style="cursor: pointer;display:flex;" (click)="onClickOfSection(0,i)"
                  [ngClass]="{'selected-style': sec.isSectionSelected}">              
                    <span class="dot mr-3 mt-1" [ngStyle]="{'background-color': sec.sectionDotColor}"></span>
                    <span class="mat-body-1">{{sec.sectionName}}</span>
                </div> -->
                <div class="row p-1"  style="cursor: pointer;display:flex;justify-content: space-between;"  
                [ngClass]="{'selected-style': sec.isSectionSelected}">
                  <div class="p-1" (click)="onClickOfSection(0,i)">              
                    <span class="dot mr-3 mt-1" [ngStyle]="{'background-color': sec.sectionDotColor}"></span>
                    <span class="mat-body-1">{{sec.sectionName}}</span>
                  </div>
                  <!-- <div class="pt-1" *ngIf="sec.sectionLookUpEntityId != null && sec.sectionLookUpEntityId.length > 0" 
                    (click)="checkEntityInstances(0,i)">
                    <mat-icon>search</mat-icon>
                  </div> -->
                </div>
              
              </div>
              <div *ngIf="surveyViewModel != null && surveyViewModel.sections.length == 0">
                <em>No sections Available!!</em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-drawer>

    <mat-drawer-content class="drawer-content-bodyScroll pt-5">
      <form id="surveyForm" class="mt-10" #surveyresponse="ngForm" style="margin-top: 100px;width: 100%;" [attr.disabled]="IsReadOnly">

        <div class="row d-flex leftdrawer-content-title leftdrawerstyle">
          <div *ngIf="imagePath != null && imagePath.length > 0" class="px-3">
            <img style="height: 30px;width: 30px;border-radius: 50%;" [src]="imagePath" alt="process logo" />
          </div>
          <div *ngIf="isStandaloneSurvey">
            <p style="font-weight:600" class="mat-title pl-3" [ngClass]="{'mx-3': imagePath==null}">
              {{standaloneSurveyDetails.name}}</p>
          </div>
          <div *ngIf="!isStandaloneSurvey">
            <h1 style="font-weight:600 !important; color:white !important" class="mat-title pl-3" [ngClass]="{'mx-3': imagePath==null}">
              {{processName}}</h1>
          </div>
        </div>

        <!-- <div *ngIf="(!isStandaloneSurvey && surveyInstanceId != null && surveyInstanceId.length > 0 
               && displayInfoData != null && displayedColumns.length > 0"> -->
        <!-- <div *ngIf="!isStandaloneSurvey && displayInfoData != null && displayedColumns.length > 0 && ((surveyInstanceId != null && surveyInstanceId.length > 0 ) || lookUpDisplayInfo)"> -->
        <div *ngIf="!isStandaloneSurvey && displayInfoData != null && displayedColumns.length > 0 ">
          <div class="row mt-5 mx-5 blue-border" aria-describedby="ProcessTable">
            <table id="ProcessTable">
              <tr>
                <th *ngFor="let disCol of displayedColumns;" class="table-heading ht">{{disCol}}</th>
              </tr>
              <tr>
                <td *ngFor="let disCol of displayedColumns;" class="ht" style="word-break: break-all;">
                  <span *ngIf="disCol != 'SurveyInstanceId'">{{displayInfoData.value[disCol]}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>




        <div class="mt-3 mx-5 style" style="overflow-x: hidden !important;">
          <div class="workflowstyle"
            style="height:40px;background: var(--main-color);color: white;padding: 9px;border-top-left-radius: 5px;border-top-right-radius: 5px;">
            <!-- <span *ngIf="IsWorkflow" class="mat-subheading-2" style="font-size: 18px !important;">{{selectedStep.name}}</span> -->
            <span *ngIf="IsWorkflow" class="mat-subheading-2" style="font-size: 18px;">{{selectedSection.sectionName}}</span>
          </div>
          <div class="m-2 p-2">
            <!-- <div *ngIf="IsWorkflow" style="border-bottom: 1px solid lightgray;" class="my-1 py-2 mat-subheading-2"> -->
              <!-- <strong class="font14">Header :</strong><span class="mat-subheading-2">
              {{selectedSection.sectionName}}</span> -->
              <!-- <strong class="mat-subheading-2" style="font-weight:600 !important;font-size: 18px !important;">
                {{selectedSection.sectionName}}</strong>
            </div> -->
            <div *ngIf="selectedSection != null  && selectedSection.sectionDescription != null && selectedSection.sectionDescription.length > 0"  style="border-bottom: 1px solid lightgray;" class="my-1 py-2 mat-subheading-2">
              <!-- <strong class="font14">Description :</strong><span class="mat-subheading-2">
              {{selectedSection.sectionDescription}}
            </span> -->
              <strong class="mat-subheading-2"
                *ngIf="selectedSection != null && selectedSection.sectionDescription != null && selectedSection.sectionDescription.length > 0"
                style="font-weight:600 !important;font-size: 18px !important;"> {{selectedSection.sectionDescription}}</strong>
              <em *ngIf="selectedSection != null && selectedSection.sectionDescription == null || selectedSection.sectionDescription.length == 0"
                style="font-size:13px;">There is no section description</em>
            </div>

            <!-- <div *ngIf="selectedSection != null" style="border-bottom: 1px solid lightgray;">
              <div class="row mat-subheading-1 cursor" *ngIf="selectedSection.sectionLookUpEntityId != null && selectedSection.sectionLookUpEntityId.length > 0" 
                (click)="checkEntityInstances()">
                <div class="row mx-1 px-2 py-1 entityInstanceBtn">
                  <span> Search {{entityDetails != null ? entityDetails.entityName : 'Entity'}} Instances</span><mat-icon class="px-2">search</mat-icon>
                </div>
              </div>  
            </div> -->
            <div *ngIf="selectedSection != null && selectedSection.sectionLookUpEntityId != null && selectedSection.sectionLookUpEntityId.length > 0" 
              [ngClass]="{'disable': IsReadOnly || (surveyInstanceId != null && surveyInstanceId.length > 0)}" >
              <div style="border-bottom: 1px solid lightgray;">
                <div class="row mat-subheading-1 cursor"
                  (click)="checkEntityInstances()">
                  <div class="row mx-1 px-2 py-1 entityInstanceBtn">
                    <span> Search {{entityDetails != null ? entityDetails.entityName : 'Entity'}}</span><mat-icon class="px-2">search</mat-icon>
                  </div>
                </div>
              </div>               
            </div>
           
            <div *ngIf="selectedSection != null">

              <div *ngFor="let que of selectedSection.questions | quesConsentFilter: selectedStep; let queInd = index;">
                <!-- <div *ngIf="que.isDeleted===null || que.isDeleted == false"> -->
               <div *ngIf="que != null && (
                      !que.isConsentQuestion
                      || (que.isConsentQuestion && que.inputType !== 'sign')
                      || (que.isConsentQuestion && que.inputType === 'sign' && selectedStep?.stepStatus == 'CP')
                    )">
                  <div *ngIf="que.inputType === 'mul' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-mul [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (conditionalChange)="isConditionalCheck($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-mul>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                      <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'chk' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != selectedSection.questions.length  && que.isParentQuestionVisible}">
                    <app-inputType-chk [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (conditionalChange)="isConditionalCheck($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-chk>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'rdo' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">                      
                    <app-inputType-radio [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (conditionalChange)="isConditionalCheck($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-radio>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'cmb' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-dropdown [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (conditionalChange)="isConditionalCheck($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-dropdown>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div
                    *ngIf="que.questionText.length > 0 && (que.inputType === 'txb' || que.inputType === 'txa') && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-text [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-text>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'rating' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-rating [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-rating>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'dte' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-date [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-date>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'fileupload' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-fileUpload [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly  || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que [isReset]="resetFlag" (childQuestion)="GetChildData($event)" (inputChange)="isInputChanged($event)" (fileUploadInProgress)="onFileUploadInProgress($event)">
                    </app-inputType-fileUpload>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'matrix' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-matrix [questionIndex]="queInd"
                      [IsReadOnly]="IsReadOnly || que.responseReadOnly  || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" [errorMessage]="que.errorMessage">
                    </app-inputType-matrix>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>                  
                  </div>
                  <div *ngIf="que.inputType === 'sign' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <app-inputType-sign [questionIndex]="queInd"
                      [IsReadOnly]="que.isConsentQuestion || IsReadOnly || que.responseReadOnly || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                      [question]=que (childQuestion)="GetChildData($event)" (inputChange)="isInputChanged($event)">
                    </app-inputType-sign>
                    <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                    </ng-container>
                    <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                     <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                    </ng-template>
                  </div>
                  <div *ngIf="que.inputType === 'displaytext' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                    <!-- Flagged badge shown BEFORE question text, only when measure isMet is false -->
                    <ng-container *ngIf="raiseDisputeMode && isFailedMeasure(que.questionId) && mappedMeasuresMap && mappedMeasuresMap[que.questionId]">
                      <span class="flagged-badge">
                        <mat-icon class="flag-icon">flag</mat-icon> Flagged
                      </span>
                    </ng-container>
                    <div class="displayFlex">
                      <app-input-type-display-text [questionIndex]="queInd"
                        [IsReadOnly]="IsReadOnly || que.responseReadOnly  || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                        [question]=que (childQuestion)="GetChildData($event)">
                        </app-input-type-display-text>
                      <span class="my-2" style="font-size: 14px; text-align: justify;"></span>                      
                    </div>
                    <!-- Review reasons listed one by one below the question text -->
                    <ng-container *ngIf="raiseDisputeMode && isFailedMeasure(que.questionId) && mappedMeasuresMap && mappedMeasuresMap[que.questionId] && mappedMeasuresMap[que.questionId].measures">
                      <div class="reason-unmet-label"><strong>Reason(s) Measure was Unmet:</strong></div>
                      <div class="review-reasons-list">
                        <ng-container *ngFor="let measure of mappedMeasuresMap[que.questionId].measures">
                          <div *ngFor="let reason of measure.reviewReasons" class="review-reason-item">
                            <mat-icon class="reason-flag-icon">flag</mat-icon>
                            <div class="reason-bubble">
                              <span>{{ reason.reasonText }}</span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    
                    <!-- Calculated measures display -->
                    <ng-container *ngIf="raiseDisputeMode && mappedMeasuresMap && mappedMeasuresMap[que.questionId] && mappedMeasuresMap[que.questionId].measures">
                      <ng-container *ngFor="let measure of mappedMeasuresMap[que.questionId].measures">
                        <div *ngIf="measure.calculationResultInfo && measure.calculationResultInfo.length > 0" style="margin-top: 16px;">
                          <div class="reason-unmet-label"><strong>Agency Measure Results:</strong></div>
                          <div *ngFor="let calcResult of measure.calculationResultInfo" class="calculation-result-item">
                            <div class="calculation-result-content">
                              <span>{{ calcResult.questionText }}:</span>
                              <strong class="calculation-result-value">{{ calcResult.calculatedValue }}</strong>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                    </div>
                  
                  <div *ngIf="que.inputType === 'table' && (!que.dataType || que.dataType=='fixed-grid') && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                   
                        <div class="displayFlex">
                          <span class="my-2" style="font-size: 14px; text-align: justify;" [innerHtml]="que.safeHtmlContent"></span>
                          <span style="margin-left: 8px;" *ngIf="que.questionToolTip">
                            <img class="dupIcon-padd iconzoom cursor"
                                matTooltip="{{que.questionToolTip}}"
                                src="/assets/icons/information_tooltip.svg"
                                alt="info icon"
                                matTooltipClass="my-custom-tooltip"
                               matTooltipPosition="above"/>
                          </span>
                        </div>
                        <app-inputType-grid [questionIndex]="queInd"
                        [mainQuestion]="que"
                          [IsReadOnly]="IsReadOnly || que.responseReadOnly  || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                           (childQuestion)="GetChildData($event)" (inputChange)="isInputChanged($event)">
                        </app-inputType-grid>
                        <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                        </ng-container>
                        <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                         <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                        </ng-template>
                  </div>

                  <div *ngIf="que.inputType === 'table' && que.dataType=='dynamic-grid' && que.isParentQuestionVisible"
                    [ngClass]="{'border-Btm': queInd +1 != (selectedSection.questions | quesConsentFilter: selectedStep).length}">
                   
                        <div class="displayFlex">
                          <span class="my-2" style="font-size: 14px; text-align: justify;" [innerHtml]="que.safeHtmlContent"></span>
                          <span style="margin-left: 8px;" *ngIf="que.questionToolTip">
                            <img class="dupIcon-padd iconzoom cursor"
                                matTooltip="{{que.questionToolTip}}"
                                src="/assets/icons/information_tooltip.svg"
                                alt="info icon"
                                matTooltipClass="my-custom-tooltip"
                                matTooltipPosition="above"/>
                          </span>
                        </div>
                        <app-inputType-dynamic-grid [questionIndex]="queInd"
                        [mainQuestion]="que"
                          [IsReadOnly]="IsReadOnly || que.responseReadOnly  || isSectionReadOnly || (que.displayMode=='ED' && !que.enableQuestion && !selectedSection.isSecParentQuestionVisible)"
                           (childQuestion)="GetChildData($event)" (inputChange)="isInputChanged($event)">
                        </app-inputType-dynamic-grid>
                        <ng-container *ngIf="showExtraComments" [ngTemplateOutlet]="Comments" [ngTemplateOutletContext]="{question: que}">
                        </ng-container>
                        <ng-template [ngIf]="failedQuestionIds.has(que.questionGuid) && showDisputeForQuestion() ">
                         <app-incident-dispute [question]="que" [dispute]="dispute" (inputChange)="isInputChanged($event)" (disputeRaised)="onDisputeRaised($event)" (fileUploadInProgress)="onFileUploadInProgress($event)"></app-incident-dispute>
                        </ng-template>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="row m-2 mx-5 py-2" style="display: flex;justify-content: space-between;" *ngIf="!raiseDisputeMode">
          <div>
            <button class="btn btnWidth-small" [disabled]="(IsReadOnly || isSectionReadOnly)"
              (click)="resetSectionWithPopUp()">Reset</button>
          </div>
          <div>
            <button class="btn btnWidth-small mr-3" [disabled]="(IsReadOnly || isSectionReadOnly)"
              (click)="savebtnClick('Save', SurveySubmissionStatus.Save)">Save & Exit</button>
            <button *ngIf="!isSaveAndClose" class="btn btnWidth-large" [disabled]="(IsReadOnly || isSectionReadOnly)"
              (click)="savebtnClick('SaveAndContinue', SurveySubmissionStatus.Save)">Save & Continue ></button>
            <button *ngIf="isSaveAndClose" class="btn btnWidth-large" [disabled]="(IsReadOnly || isSectionReadOnly)"
              (click)="savebtnClick('Submit', SurveySubmissionStatus.Submit)">Submit & Close ></button>
          </div>
        </div>
        <div class="row m-2 mx-5 py-2" style="display: flex;justify-content: space-between;" *ngIf="raiseDisputeMode">    
           <div>
            <button class="btn btnWidth-small" [disabled]="isDisputeRaised"
              (click)="resetDisputeSectionWithPopUp()">Reset</button>
          </div>
          <div>    
            <button class="btn btnWidth-small mr-3" [disabled]="FileUploading"
                (click)="saveDispute('SaveAndExit')">Save & Exit</button>
            <button *ngIf="!isSaveAndClose" class="btn btnWidth-large" [disabled]="FileUploading"
                (click)="saveDispute('SaveAndContinue')">Save & Continue ></button>
            <button *ngIf="isSaveAndClose" class="btn btnWidth-large" [disabled]="FileUploading"
                (click)="saveDispute('Submit')">Submit & Close ></button>
          </div>
        </div>




        <ng-template #Comments let-question='question'>

          <div *ngIf="question.comments || isCommentsEditable==true" [ngClass]="{'offset-6' : question.inputType != 'table'}">
            <div class="my-2 pl-3">
              <mat-checkbox type="checkbox" title="Add Comments" [id]="question.questionId"
                (change)="toggleComment($event,question)"
                [checked]="question.comments!=null && question.comments!=undefined" [disabled]="!isCommentsEditable"
                *ngIf="question.comments || isCommentsEditable==true"></mat-checkbox>

              <span class="ml-3">Add Comments</span>
            </div>
            <div class="my-3 pl-4 ml-1">
              <textarea [name]="question.questionId" rows=3 cols=120 [(ngModel)]="question.comments"
                placeholder="Enter Comments" [disabled]="!isCommentsEditable" 
                *ngIf="question.comments!=null && question.comments!=undefined" class="txtComments"
                style="width:60%"></textarea>
            </div>

          </div>
        </ng-template>



        <!--disclaimer popup if sign is included-->
        <app-modal [modalSize]="consentModalSize" [modalText]="modalDisclaimerText"
          *ngIf="!hideDisclaimerPopUp" (modalClose)="closeDisclaimerPopup()" [isDraggable]="false" [resize]="true">
          <div class="modal-body">
            <p> {{esignConsent}} </p>
          </div>
          <div class="modal-footer">
            <div class="flex-end" style="text-align: center;padding: 3px;">
              <app-button style="margin-top: -30px;" title="ACCEPT" [btnText]="yesBtnText" [btnStyle]="btnWithText"
                [btnType]="btnRect" [btnSize]="btnXlarge" (btnClick)="submitWithDisclaimer()">
              </app-button>
              &nbsp;
              <app-button style="margin-top: -30px;" title="DECLINE" [btnText]="noBtnText" [btnStyle]="btnWithText"
                [btnType]="btnRect" [btnSize]="btnXlarge" (btnClick)="closeDisclaimerPopup()">
              </app-button>
            </div>
          </div>
        </app-modal>


        <!-- <app-modal class="DisclaimerPopup" [modalSize]="modalDisclaimerSize" [modalText]="modalClearRespPopupText" 
        *ngIf="showClearResponsesPopUp" (modalClose)="closeClearResponsesPopup()">
          <div class="modal-body">
            <p> {{clearPopupText}} </p>
          </div>
          <div class="modal-footer">
            <div class="flex-end" style="text-align: center;padding: 3px;">
              <app-button style="margin-top: -30px;" title="PROCEED" [btnText]="proceedBtntext" [btnStyle]="btnWithText"
                [btnType]="btnRect" [btnSize]="btnXlarge" (btnClick)="clearResponses()">
              </app-button>
              &nbsp;
              <app-button style="margin-top: -30px;" title="CANCEL" [btnText]="cancelBtntext" [btnStyle]="btnWithText"
                [btnType]="btnRect" [btnSize]="btnXlarge" (btnClick)="closeClearResponsesPopup()">
              </app-button>
            </div>
          </div>         
       </app-modal> -->

      </form>


      <div class="arrow-btn-style" (click)="drawer.toggle();changeArrowIcon();"
        (keypress)="drawer.toggle();changeArrowIcon();">
        <!-- <mat-icon *ngIf="!arrowIconToggle" class="arrowIconStyle">keyboard_arrow_left</mat-icon>
        <mat-icon *ngIf="arrowIconToggle" class="arrowIconStyle">keyboard_arrow_right</mat-icon> -->
            <img class="sidetoggle" *ngIf="arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
            <img class="sidetoggle" *ngIf="!arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
      </div>

    </mat-drawer-content>
  </mat-drawer-container>


  <app-modal *ngIf="showEntityInstancePopUp" class="popup-style" [modalSize]="modalInstanceSize" [modalText]="modalInstanceText" (modalClose)="closeInstancePopUp()">
    <div class="modal-body p-2">

      <!--Filters-->
      <!-- <form [formGroup]="searchForm" [ngClass]="{'pad150':hideCreateIncident}">
        <mat-accordion class="col-12 my-2">
        <mat-expansion-panel class="w-100 mat-elevation-z0 matPanel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <p class="pt-3 mat-subheading-1 lightBlue">Apply search filters</p>
            </mat-panel-title>        
          </mat-expansion-panel-header>

          <div class="col-12 mt-2 d-flex" style="flex-wrap: wrap !important;">
            <div class="row col-6 p-2" *ngFor="let field of searchableFields; let i=index">
              <div class="col-4 px-1 align-items-center"> {{field.entityFieldName}}</div>
              <div class="col-6 px-1">
                <ng-container *ngIf="field.questionMasters.inputType == 'dte'">
                    <input class="blue-border ht-30 w-100" id="{{field.questionMasters.questionId}}" type="date"/>
                </ng-container>
                <ng-container *ngIf="field.questionMasters.inputType != 'dte'">                   
                    <input  id="{{field.questionMasters.questionId}}"  class="blue-border ht-30 w-100" (change)="onSearch($event,field)">
                </ng-container>
              </div>
            </div>                           
            <div *ngIf="searchableFields.length == 0" class="m-4">
              <div class="d-flex justify-content-center mat-subheading-1">No Advanced Filters set</div>
            </div>
          </div>

          <mat-action-row class="pr-4">
            <button mat-raised-button  [disabled]="searchableFields.length == 0" class="apply-button" (click)="applySearch($event)">Search</button>
            <button mat-raised-button  [disabled]="searchableFields.length == 0" class="reset" (click)="resetSearch($event)">Reset</button>
          </mat-action-row>

        </mat-expansion-panel>
        </mat-accordion>
      </form> -->
      <!--Instances Table-->
      <div class="d-flex justify-content-center col-12 px-0 pt-5">
        <div class="row entityDet-title mt-2 col-12 p-0 m-0 borderRadBtm" *ngIf="dataEntityInstanceSource.data.length > 0">
          <table mat-table class="w-100" aria-describedby="Data entity Instances"
            [dataSource]="dataEntityInstanceSource.data | paginate: {itemsPerPage: size, currentPage: pageIndex, totalItems: totalItems}">
            <!-- <ng-container matColumnDef="header-row-top-group">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]=displayedEntityInstanceColumns.length>
                <div class="mat-caption">
                  Items per page:
                  <mat-select [(value)]="size" (valueChange)="paginate(pageIndex)"
                    style="width: 50px;margin-left: 15px">
                    <mat-option [value]="5">5</mat-option>
                    <mat-option [value]="10">10</mat-option>
                    <mat-option [value]="20">20</mat-option>
                  </mat-select>
                </div>
              </th>
            </ng-container> -->


            <ng-container *ngFor="let disCol of displayedEntityInstanceColumns; let colIndex = index" matColumnDef="{{disCol}}">
              <div *ngIf="disCol == 'Icon'">
                <th  mat-header-cell *matHeaderCellDef class="head"><strong>Select</strong></th>
                <td mat-cell *matCellDef="let element">
                  <mat-radio-button class="pt-2" (click)="onSelectingEntityInstance($event,element)"></mat-radio-button>               
                </td>
              </div> 
              <div *ngIf="disCol != 'Icon'">
                <th  mat-header-cell *matHeaderCellDef class="head"><strong>
                  <!-- {{disCol != 'CreatedByUserName'  ? (disCol == 'EntityInstanceName'  ? 'Instance Name' : disCol) : 'Created By'}}</b></th> -->
                  {{disCol != 'CreatedByUserName'  ?  disCol : 'Created By'}}</strong></th>
                <td mat-cell *matCellDef="let element" >
                  <!-- <span *ngIf="disCol == 'Created On'">{{element.value[disCol] | date }}</span> 
                  <span *ngIf="disCol != 'Created On'">{{element.value[disCol] }}</span>  -->
                  <span>{{element.value[disCol]}}</span>
                </td>               
              </div>
            </ng-container>

            <ng-container matColumnDef="header-row-first-group">
              <th mat-header-cell *matHeaderCellDef class="thRadius" [attr.colspan]=displayedEntityInstanceColumns.length>
                <div class="mat-subheading-1 text-left pt-3 heading-color">
                  <p [attr.aria-valuenow]="selectedOrgName" class="mat-subheading-1">
                    {{entityDetails != null ? entityDetails.entityName : ''}}
                  </p>
                </div>
              </th>
            </ng-container>
           
            <ng-container matColumnDef="noData">
              <mat-footer-cell *matFooterCellDef [attr.colspan]="displayedEntityInstanceColumns.length">
                No records found
              </mat-footer-cell>
            </ng-container>
            
            <tr mat-header-row class="tableHeading" *matHeaderRowDef="['header-row-first-group']; sticky: true">
            </tr>
            <!-- <tr mat-header-row *matHeaderRowDef="['header-row-top-group']; sticky: true">
            </tr> -->
            <tr mat-header-row *matHeaderRowDef="displayedEntityInstanceColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedEntityInstanceColumns;"></tr>
            <tr mat-footer-row class="mat-body-1" *matFooterRowDef="['noData']" [hidden]="dataEntityInstanceSource && dataEntityInstanceSource.data.length > 0"></tr>
          </table>        
          <div class="pagination borderRadBtm">
            <pagination-controls  (pageChange)="paginate($event)"></pagination-controls>
          </div>
        </div>
        <div *ngIf="dataEntityInstanceSource.data.length == 0" class="col-12 p-0">
          <mat-card class="col-12 py-2 blue-border remShad mat-subheading-1">
            <span  class="lightBlue px-2">No records found</span>
          </mat-card>        
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="flex-end" style="text-align: center;padding: 3px;">
        <!-- <app-button style="margin-top: -30px;" title="Ok" [btnText]="'OK'" [btnStyle]="btnWithText"
          [btnType]="btnRect" [btnSize]="btnXlarge" (btnClick)="ok()"  [ngClass]="{'disable':selectedEntityInstanceId != null && selectedEntityInstanceId.length == 0}">
        </app-button> -->
        <!-- &nbsp; -->
        <!-- <app-button style="margin-top: -30px;" title="Cancel" [btnText]="'Cancel'" [btnStyle]="btnWithText" 
       
          [btnType]="btnRect" [btnSize]="btnXlarge" (btnClick)="closeInstancePopUp()">
        </app-button> -->
        <button mat-stroked-button color="primary" 
        [ngClass]="{'disable':selectedEntityInstanceId == null || selectedEntityInstanceId.length == 0}"
        style="margin-top: -30px;" class="apply-button" (click)="ok()"> 
          Done</button>
          &nbsp;
        <button mat-stroked-button color="primary" style="margin-top: -30px;" class="reset" (click)="closeInstancePopUp()"> 
          Cancel</button>
      </div>
    </div>
  </app-modal>

</ng-template>